import { useTranslation } from 'react-i18next';
import type { TransferToTeamSubmitPayload } from 'v5/patterns/forms/dialogs/TransferToTeamDialogContent';
import { MountElementProps } from 'v5/messages/mount-element';
import { TransferToTeamDialog } from 'v5/patterns/forms/dialogs/TransferToTeamDialog';
import { WithServices } from 'v5/platform/ts/services';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';

export type TransferProductionDialogProps = MountElementProps &
  WithServices<[WithEnterpriseService]> & {
    organizationId: string;
    productionName: string;
    productionCount?: number;
    currentWorkspaceId?: number | null;
    currentTeamId?: number | null;
    onSubmit: (payload: TransferToTeamSubmitPayload) => Promise<void>;
  };

export function TransferProductionDialog({
  productionName,
  productionCount,
  ...props
}: TransferProductionDialogProps) {
  const { t } = useTranslation('productions', {
    keyPrefix: 'TransferProductionDialog'
  });

  const descriptionMessage = t('description', {
    count: productionCount,
    name: productionName
  });

  return (
    <TransferToTeamDialog
      {...props}
      titleMessage={t('title')}
      descriptionMessage={descriptionMessage}
      fieldWorkspaceMessage={t('fieldWorkspace')}
      fieldTeamMessage={t('fieldTeam')}
    />
  );
}
